import { HomeLayout } from "@dust-tt/front/components/home/HomeLayout";
import { useAuth, useWorkspace } from "@dust-tt/front/lib/auth/AuthContext";
import { Outlet } from "react-router-dom";

/**
 * Router layout for Home, the workspace landing route. Mirrors
 * ConversationRouterLayout: it hands the auth context to the shared layout.
 */
export function HomeRouterLayout() {
  const owner = useWorkspace();
  const {
    subscription,
    user,
    isAdmin,
    isManager,
    featureFlags,
    vizUrl,
    providersHealth,
    workspacePermissions,
  } = useAuth();

  const pageProps = {
    workspace: owner,
    subscription,
    user,
    isAdmin,
    isManager,
    featureFlags,
    vizUrl,
    providersHealth,
    workspacePermissions,
  };

  return (
    <HomeLayout pageProps={pageProps}>
      <Outlet />
    </HomeLayout>
  );
}
